import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/free-solid-svg-icons";

const euros = (cents) => `${((cents || 0) / 100).toFixed(2).replace(".", ",")} €`;

const daysLabel = (days) => {
  if (days === 0) return "aujourd'hui";
  if (days === 1) return "hier";
  if (days < 31) return `il y a ${days} jours`;
  const months = Math.round(days / 30);
  return months < 12 ? `il y a ${months} mois` : "il y a plus d'un an";
};

/**
 * Bandeau d'historique SAV du client, en haut de la modale : l'agent doit savoir
 * s'il a déjà dédommagé ce client, quand et pourquoi, avant d'accorder un geste.
 */
const SavCustomerHistory = (props) => {
  const { history } = props;

  if (!history) return null;

  const { count, totalAmount, ordersCount, last, alert, windowMonths } = history;

  if (!count) {
    return (
      <div className="alert alert-light py-2 px-3 mb-2" style={{ border: "1px solid #e0e0e0" }}>
        <FontAwesomeIcon icon={faHistory} className="mr-2" />
        Aucun SAV sur {windowMonths} mois — {ordersCount} commande{ordersCount > 1 ? "s" : ""}.
      </div>
    );
  }

  return (
    <div className={`alert ${alert ? "alert-warning" : "alert-light"} py-2 px-3 mb-2`} style={alert ? {} : { border: "1px solid #e0e0e0" }}>
      <FontAwesomeIcon icon={faHistory} className="mr-2" />
      <b>{count} SAV</b> sur {windowMonths} mois
      {last && (
        <>
          {" · dernier "}<b>{daysLabel(last.daysAgo)}</b>
          {last.categoryLabel ? ` (${last.categoryLabel})` : ""}
          {last.amount > 0 ? ` — ${euros(last.amount)}` : ""}
        </>
      )}
      {" · "}{euros(totalAmount)} crédités · {ordersCount} commande{ordersCount > 1 ? "s" : ""}
      {alert && (
        <div style={{ fontSize: "0.85rem" }}>
          Client déjà dédommagé récemment ou souvent : vérifiez avant d'accorder un nouveau geste.
        </div>
      )}
    </div>
  );
};

SavCustomerHistory.propTypes = {
  history: PropTypes.object,
};

export default SavCustomerHistory;
